import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPendingReviewIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5 9C7.20914 9 9 7.20914 9 5C9 2.79086 7.20914 1 5 1C2.79086 1 1 2.79086 1 5C1 7.20914 2.79086 9 5 9Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 5.00002,
		cy: 5.00002,
		r: 2.09524,
		fill: "currentColor"
	})]
});
export default SvgPendingReviewIcon;
